import Breadcrumbs from "@components/shared/miscellaneous/breadcrumbs/breadcrumbs";
import { useRouter } from "next/router";
import style from './author-page.module.scss';
import Image from "next/image";
import ArticlePreviewMedium from "../article-previews/article-preview-medium/article-preview-medium";
import iconLinkedin from '/public/assets/icons/icn-linkedin.svg'
import arrowRight from '/public/assets/icons/icn-arrow-right.svg'

import ReactPaginate from "react-paginate";
import { getArticles } from "@services/blog.service";
import Link from "next/link";
import { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { getAuthorsArticles } from "@services/author.service";
import AuthorPageState from "./author-page.state";


const FIRST_PAGE = 1;
const LIMIT = 9;

const AuthorPage = (props: any) => {
    const [authors, setAuthors] = useState(props.authors || []);

    const router = useRouter();
    const [currentPage, setCurrentPage] = useState<number>(props.page ?? FIRST_PAGE);
    const [totalCount, setTotalCount] = useState(props.total || 0);
    const [articles, setArticles] = useState(props.articles.data || []);
    const [currentAuthor, setCurrentAuthor] = useState(props.author);
    const authorSlug = encodeURIComponent(props.author.slug);

    const handlePageClick = (event: any) => {
        const newestPage = event.selected + 1;
        setQueryParams(newestPage);

        getAuthorsArticles(true, event.selected * LIMIT, LIMIT, props.author.slug)
            .then((data: any) => {
                if (currentPage === 0) {
                    setArticles(data.data);
                } else {
                    setArticles([...data.data]);
                }
                setCurrentPage(() => newestPage);
                setTotalCount(data.total);
            })
    };

    useEffect(() => {
        if (articles.length > 0) {
            scrollToBlock('articleId');
        }
    }, [articles]);

    
    useEffect(() => {
        document.documentElement.style.scrollBehavior = "auto";
        return () => {
            document.documentElement.removeAttribute("style");
        };
      }, []);

    useEffect(() => {
        setAuthors(props.authors || []);
        setCurrentPage(props.page ?? FIRST_PAGE);
        setTotalCount(props.total || 0);
        setArticles(props.articles.data || []);
    }, [props]);

    useEffect(() => {
        if (currentAuthor !== props.author) {
            setCurrentAuthor(props.author);
            scrollToTop();
        }
    }, [props.author.name]);


    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
        });
    };

    const getPageCont = () => {
        return (!totalCount || totalCount <= LIMIT) ? 1 : (Math.trunc(totalCount / LIMIT) + +!!(totalCount % LIMIT));
    }

    const setQueryParams = (newestPage: number): void => {

        let query = {};
    
        if (newestPage !== FIRST_PAGE) {
            query = Object.assign(query, { page: newestPage });
        }
    
        const pathname = `/blog/authors/${authorSlug}`;
    
        router.push({
            pathname,
            query,
        }, undefined, { scroll: false })
        .catch(e => {
            console.error(e);
        });
    };

    function scrollToBlock(blockId: string) {
        const element = document.getElementById(blockId);
        const y = (element?.getBoundingClientRect().top || 0) + window.pageYOffset - 100;
        window.scrollTo({ top: y, behavior:"smooth" });
    }

    const arrowElementHandler = (isPrevious = false): JSX.Element => {
        const page = arrowPageCalc(isPrevious);
        return (<>
            <Link scroll={false} href={`${router.query.author}${buildQueryParams(page)}`}
                shallow={true}>
                <ReactSVG style={{ maxWidth: '24px', maxHeight: '24px' }}
                    src={isPrevious ? '/blog-images/arror-left.svg' : '/blog-images/arror-right.svg'} />
            </Link>
        </>);
    }

    const hrefHandler = (pageIndex: number): string => {        
        return `/blog/authors/${authorSlug}${buildQueryParams(pageIndex)}`;
    }
    
    const buildQueryParams = (page: number): string => {
        const pageQuery = page === FIRST_PAGE ? '' : ('page=' + page);
        return `${!!pageQuery ? '?' + pageQuery : ''}`;
    };

    const arrowPageCalc = (isPrevious: boolean): number => {
        const prevPage = (currentPage - 1);
        const nextPage = (currentPage + 1);
        return isPrevious ? (prevPage !== 0 ? prevPage : 1) : nextPage < getPageCont() ? nextPage : currentPage;
    }


    const paginationRender = () => {
        if (props.articles.data.length) {

            return <>
                <ReactPaginate
                    nextLabel={arrowElementHandler()}
                    forcePage={(currentPage - 1)}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    marginPagesDisplayed={1}
                    pageCount={getPageCont()}
                    previousLabel={arrowElementHandler(true)}
                    pageClassName="page-item page-label"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    hrefBuilder={(pageIndex: number) => hrefHandler(pageIndex)}
                    breakLabel={<div>
                        <div className='mobile'>{`Page ${currentPage} of ${getPageCont()}`}</div>
                        <div className='desktop'>...</div>
                    </div>}
                    breakClassName="page-item page-item-break"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                />
            </>
        } else {
            return null;
        }
    }

    return (
        <>
            <div className={style.container} id="startPage">
                <div className={style.author_header}>
                    <Breadcrumbs  lastElementTitle={props.author.name}/>
                    <div className={style.author_header_wrapper}>
                
                        <div className={style.author__dekstop}>
                        <div className={style.author__image}>
                                <Image sizes="1024px" layout={'fill'} src={props.author.avatarUrl} alt={props.author.header} />
                            </div>
                                <div className={style.author__info}>
                                    <h1 className={style.name}>{props.author.name}</h1>
                                    <div className={style.action}>
                                        <span className={style.postion}>{props.author.position} </span>
                                        
                                        {props.author.profileLink && (
                                                <><div className={style.vertical_line}></div><Link scroll={false} href={`${props.author.profileLink}`}>
                                                    <a target="_blank" rel="noopener noreferrer">
                                                        <div className={style.img_container}>
                                                            {AuthorPageState.map((item, index) => (
                                                                <div key={index} className={item.className} dangerouslySetInnerHTML={{ __html: item.icon }}></div>
                                                            ))}
                                                        </div>
                                                    </a>
                                                </Link></>
                                              )}
                                    </div>
                                    <span className={style.discription}>{props.author.aboutAuthor}</span>
                                </div>
                          
                        </div>
             

                     <div className={style.author__tablet}>
                     <div className={style.author__info}>
                                    <div className={style.author__info__wrapper}>
                                        <div className={style.author__image}>
                                            <Image sizes="1024px" layout={'fill'} src={props.author.avatarUrl} alt={props.author.header} />
                                        </div>
                                        <div className={style.author__action}>
                                            <span className={style.name}>{props.author.name}</span>
                                            <div className={style.author__position}>
                                                <span className={style.postion}>{props.author.position} </span>
                                        {props.author.profileLink && (

                                                <><div className={style.vertical_line}></div><Link scroll={false} href={`${props.author.profileLink}`}>
                                                    <a target="_blank" rel="noopener noreferrer">
                                                        <div className={style.img_container}>
                                                            {AuthorPageState.map((item, index) => (
                                                                <div key={index} className={item.className} dangerouslySetInnerHTML={{ __html: item.icon }}></div>
                                                            ))}
                                                        </div>
                                                    </a>
                                                </Link></>

                                              )}

                                            </div>
                                        </div>
                                    </div>
                                    <span className={style.discription}>{props.author.aboutAuthor}</span>
                                </div>
                     </div>
     

                    </div>
                </div>
                <div className={style.article_wrapper} id="articleId">
                    <h2 className={style.article_title}>Articles by this author</h2>
                    <div className={style.article__list}>
                        {articles.map((article: any) => (
                            <ArticlePreviewMedium key={article.id} article={article} />
                        ))}
                    </div>
                    {paginationRender()}
                </div>
                <div className={style.authors}>
                    <div className={style.authors__container}>
                        <div className={style.authors__description}>
                            <div className={style.authors__title}>
                                Our authors
                            </div>
                            <div className={style.authors__subtitle}>
                                We are introducing the team of authors creating the content for us. With every author ranging from an experienced industry professional to a visionary, every contributor is committed to equipping with the information that would enable teams to excel.</div>
                            <div>
                            </div>
                        </div>
                        <div className={style.authors__card__wrapper}>
                            {authors.map((Oneauthor: any, index: any) => (
                                <Link scroll={false} href={`/blog/authors/${Oneauthor.slug}`} key={index}>
                                    <a>
                                        <div key={index} className={style.authors__card} >
                                            <div className={style.author__card__image__wrapper}>
                                                {Oneauthor.avatarUrl ? (
                                                    <Image className={style.author__card__image} src={Oneauthor.avatarUrl} alt={Oneauthor.name} layout="fill" objectFit="cover" />
                                                ) : (
                                                    <div>No photo available</div>
                                                )}
                                            </div>
                                            <div className={style.authors__info__wrapper}>
                                                <div className={style.authors__info}>
                                                    <div className={style.authors__info__title}>{Oneauthor.name}</div>
                                                    <div className={style.authors__subtitle}>{Oneauthor.position}</div>
                                                </div>
                                            </div>
                                            <div className={style.arrow__right}>
                                                <Image src={arrowRight} layout="fill" objectFit="cover" />
                                            </div>
                                        </div>
                                    </a>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AuthorPage;
